<template>
  <div class="container">
    <div class="content">
      <Info />
      <div class="">
          <component :is="componentName" @regist="handleRegist" class="main-content"></component>
      </div>
    </div>
    <!-- <global-footer :copyright="copyright" :copyno="copyno" /> -->
  </div>
</template>

<script>
import GlobalFooter from '../common/GlobalFooter'
import Login from './Login'
import Regist from './Regist'
import Info from './Info'

export default {
  name: 'Common',
  components: {GlobalFooter, Login, Regist, Info},
  data () {
    return {
      componentName: 'Login'
    }
  },
  computed: {
    systemName () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.systemName
      } else {
        return this.$store.state.setting.systemNameEn
      }
    },
    copyright () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.copyright
      } else {
        return this.$store.state.setting.copyrightEn
      }
    },
    copyno () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.copyno
      } else {
        return this.$store.state.setting.copynoEn
      }
    }
  },
  methods: {
    handleRegist (val) {
      this.componentName = val
    }
  }
}
</script>

<style lang="less" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100vw;
    overflow: auto;
    padding: 0 15vw;
    background: #E6F7FF url('../../../static/img/login-bg.png') no-repeat center;
    background-size: 100% 100%;
    .content {
      flex: 1;
      display: flex;
      padding: 10px;
      @media (min-width: 768px){
        padding: 116px 0 10px;
      }
      .main-content {
        width: 350px;
        height: 380px;
        margin: 0 auto;
        margin-top: 150px;
        @media screen and (max-width: 576px) {
          // width: 95%;
        }
        @media screen and (max-width: 320px) {
          .captcha-button{
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/Common.vue